import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { LineHeightIcon } from 'src/editor/shared/icons/line-height-icon'
import { NumberInput } from 'src/editor/shared/ui-lib/input/number-input'

export interface LineHeightControlProps {
  lineHeight: number | undefined
  mobileLineHeight?: number | undefined
  update: (value: number) => void
  mobileUpdate?: (value: number) => void
  className?: string
}

export const LineHeightControl = ({
  lineHeight,
  mobileLineHeight,
  update,
  mobileUpdate,
  className,
}: LineHeightControlProps) => {
  const { isMobile } = useDeviceModeContext()

  const resultLineHeight = (
    isMobile ? mobileLineHeight || lineHeight : lineHeight
  ) as number

  const onChange = isMobile ? mobileUpdate || update : update

  return (
    <NumberInput
      value={resultLineHeight}
      onChange={onChange}
      min={8}
      startElement={<LineHeightIcon />}
      className={className}
    />
  )
}
